import React from 'react';
import styled from 'styled-components';

const Col = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${({ align }) => align};
  justify-content: ${({ justify }) => justify};
  padding: ${({ padding }) => padding};
  margin: ${({ margin }) => margin};
  ${({ debug }) => (debug ? 'border: 1px dashed gray;' : '')}
  @media (max-width: 768px) {
          margin: 10px;
          padding: 3px;
        }
`;

export default ({
  children,
  debug = false,
  align = 'center',
  justify = 'center',
  padding = '0',
  margin = '0',
  style,
  ...props
}) => (
  <Col
    debug={debug}
    align={align}
    justify={justify}
    padding={padding}
    margin={margin}
    style={style}
    {...props}>
    {children}
  </Col>
);
